import React, { useEffect } from "react";
import { useTour } from "../components/ui/TourContext";
import AppRoutes from "./app-route";

function AuthenticatedApp({ props, isLoading, path, clients, emps }) {
  const { startTour } = useTour();

  useEffect(() => {
    if (isLoading) return;
    if (path !== "/dashboard") return;

    const blockedRoutes = [
      "/",
      "/login",
      "/register",
      "/verify-email-sent",
      "/verify-email",
      "/verify-new-email",
      "/updatepassword",
      "/forgotpassword",
    ];
    if (blockedRoutes.includes(path)) return;

    const hasSeenTour = localStorage.getItem("hasSeenTour");
    if (hasSeenTour) return;

    if (Array.isArray(clients) && Array.isArray(emps) && clients?.length === 0 && emps?.length === 0) {
      localStorage.setItem("startTour", "getting-started");
      startTour("getting-started");
    }
  }, [isLoading, path, clients, emps, startTour]);

  return <AppRoutes {...props} isLoading={isLoading} />;
}

export default AuthenticatedApp;